import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { APIService } from '../api.service';
import { CommonService } from '../services/common.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VoucherEntryComponent } from '../voucher-entry/voucher-entry.component';
import * as xlsx from 'xlsx';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-voucher-search',
  templateUrl: './voucher-search.component.html',
  styleUrls: ['./voucher-search.component.scss']
})

export class VoucherSearchComponent implements OnInit {

  constructor(private commonSer: CommonService, private apiService: APIService, private commonService: CommonService, private modalService: NgbModal, private appService: DataService, private router: Router) { }

  displayedColumns: string[] = ['VoucherNo', 'Type', 'Date', 'DbLedger', 'CrLedger', 'Debit', 'Credit', 'Notes', 'Actions'];
  dataSource = new MatTableDataSource();
  filteredOptions: Observable<string[]> | undefined;
  myControl = new FormControl();
  DefStockRateFilter = new FormControl('');


  button: boolean = false;

  filter: number = 2;
  closeResult: string = '';

  months: any = [];
  yearList: any = [];
  financialYears: any = [];
  voucher: any = [];
  jarvisData: any = [];
  agencyData: any = [];

  curDate: any = new Date();
  acctStartDT: Date = new Date();
  fromDate: Date = new Date("2021-Apr-01");
  toDate: Date = new Date("2022-Mar-31");

  year: any;
  month: any;
  selectedFY: any;
  modalReference: any;


  view = {
    month: this.curDate.getMonth() + 1,
    year: this.curDate.getFullYear()
  }

  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;


  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  type = [
    {
      id: 1,
      name: 'Bank Payment'
    },
    {
      id: 2,
      name: 'Bank Receipt'
    },
    {
      id: 3,
      name: 'Cash Payment'
    },
    {
      id: 4,
      name: 'Cash Receipt'
    },
    {
      id: 5,
      name: 'Journal Voucher'
    },
    {
      id: 6,
      name: 'Purchase Voucher'
    },
    {
      id: 7,
      name: 'Sale Voucher'
    },
    {
      id: 8,
      name: 'Contra Entry'
    },
    {
      id: 9,
      name: 'Salary'
    }
  ]



  ngOnInit(): void {
    let yearmonth = this.commonSer.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));

    var tempyearList = [];
    for (let i = 0; i < yearmonth.length; i++) {
      tempyearList.push(yearmonth[i].year)
    }

    this.yearList = tempyearList.filter((item, index, array) => {
      return array.indexOf(item) === index
    })

    this.year = this.curDate.getFullYear();
    this.month = this.curDate.getMonth();
    this.getPeriodData();

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    let accountsDate: any = this.apiService.getCookie("AccountsDates");
    if (accountsDate) {
      accountsDate = JSON.parse(accountsDate);
      if (accountsDate.length > 0) {
        this.selectedFY = accountsDate[0].selectedFy;
        this.toDate = new Date(accountsDate[0].tdt);
        // this.toDate=this.toDate.replace(/%20/g, " ");
        this.fromDate = new Date(accountsDate[0].fdt);
        //this.fn_ChangeDate();

        if (this.selectedFY != "Other") {
          let selectedYear = this.selectedFY.split("-");
          let accountDate: Array<any> = [{
            fdt: '1-Apr-' + selectedYear[0],
            tdt: '31-Mar-' + selectedYear[1],
            selectedFy: this.selectedFY
          }];
          this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
        }
      }
      else {
        this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
        let currentDate = new Date();
        this.fn_Set_FinancialYear(currentDate);
      }
    }
    else {
      this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
      let currentDate = new Date();
      this.fn_Set_FinancialYear(currentDate);
    }

    this.getVoucherData();
  };

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getmonthyear() {
    let selecetdYear = this.months.filter((a: any) => a.id == this.view.month);
    if (selecetdYear) {
      for (let i = 0; i < selecetdYear.length; i++) {
        this.year = selecetdYear[i].year;
        this.month = selecetdYear[i].number
      }
    }
    this.getVoucherData();
  }

  //getData()
  getVoucherData() {
    var tempData = [{
      'Month': this.month,
      'Year': this.year,
      'TypeID': 0
      //'month': 1,
      //'year': 2021,  
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 0,
      data: JSON.stringify(tempData),
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          var dataRes = reponseData.Table;

          if (dataRes[0].ErrCode == -1) {
            reponseData.Table1.forEach((e: any) => {
              var vouchertype = this.type.filter(function (element: any, index: any) {
                return (element.id == e.VoucherTypeID);
              });
              if (vouchertype.length > 0) {
                e.voucherType = vouchertype[0].name;
              }
            });
            this.dataSource.data = reponseData.Table1
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.matSort;
          }
        }
      }
    }
  }

  failureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }


  typeFilter(id: number) {
    this.filter = id;

    if (this.filter == 1) {
      this.month = this.curDate.getMonth() + 1;
      this.year = this.curDate.getFullYear();
      this.view.month = this.curDate.getMonth() + 1;
      this.view.year = this.curDate.getFullYear();
    }

    if (this.filter == 2) {
      this.month = this.curDate.getMonth();
      this.year = this.curDate.getFullYear()
      this.view.month = this.curDate.getMonth() + 1;
      this.view.year = this.curDate.getFullYear();
    }
    this.getVoucherData();

  }

  // changeMonth() {
  //   this.month = this.view.month;
  //   this.year = this.view.year;
  //   //this.getPeriodData();
  //   this.getVoucherData();
  // }

  getPeriodData() {
    this.months = this.commonSer.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    return;
  }

  yearChange() {
    this.getPeriodData();
    this.getVoucherData();
  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-")[0] + "";
      let toDate = (Number(selectedYear) + 1) + "/03/31";
      //this.selectedDate = toDate;

      let accountDate: Array<any> = [{
        fdt: '1-Apr-' + selectedYear[0],
        tdt: '31-Mar-' + selectedYear[1],
        selectedFy: this.selectedFY
      }];
      // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
      this.fn_Set_FinancialYear(toDate);
    }
  }


  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }
    //this.getData();
    this.getVoucherData();
  }


  editVoucher(content: any, row: any) {

    this.modalReference = this.modalService.open(VoucherEntryComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'Edit-V', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.voucherID = row.VoucherID;
    this.modalReference.componentInstance.mdlRefHide = this.modalReference
    this.modalReference.result.then((result: any) => {
      // if (result == true) {
      //   //this.getData();
      //   this.appService.updateVoucherEntered(1);
      // }
      this.closeResult = `Closed with: ${result}`;
      this.getVoucherData();
      //this.getData();
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //this.getData();
      this.getVoucherData();
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  printVoucher(id: number) {
    var VID = id;
    window.open('voucherPrint?VID=' + VID, '_blank', 'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.json_to_sheet(this.dataSource.data);
    //xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'Voucher.xlsx');
  }

  refresh() {
    //window.location.reload();
    // this.getData();
    this.getVoucherData();
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  fn_ChangeDate() {
    // Here Set Accounting Year of Selected Date
    var Date2 = new Date(this.fromDate);
    var Date1 = new Date(this.toDate);
    var acctStartDT = new Date(this.acctStartDT);
    let CurrentDate = new Date();

    if (Date1 < acctStartDT) {
      alert("Please select date after " + this.acctStartDT.customFormat("#DD#-#MMM#-#YY#"));
      this.fn_Set_FinancialYear(CurrentDate);
      return;
    }

    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      Date2 = new Date(Year + "/04/01");
      //this.fromDate = new Date(Year + "/04/01");
      //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      Date2 = new Date(Date1.getFullYear() + "/04/01");
      //this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      // $scope.ToDate = new Date(Year + "/03/31");
    }

    // let accountDate: Array<any> = [{
    //   fdt: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
    //   tdt: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#"),
    //   selectedFy: this.selectedFY
    // }];
    //   this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
    this.getVoucherData();

  }

}
